export default function ArrowSmallIcon() {
  return (
    <svg
      className='fill-current inline ml-sm'
      width='11'
      height='18'
      viewBox='0 0 11 18'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M0.803203 15.2036L7.03758 8.96918L0.803203 2.7348C0.654443 2.58604 0.53644 2.40944 0.455931 2.21507C0.375423 2.02071 0.333984 1.81239 0.333984 1.60201C0.333984 1.39163 0.375423 1.18331 0.455931 0.988949C0.53644 0.794584 0.654443 0.617979 0.803203 0.469219C0.951964 0.320458 1.12857 0.202455 1.32293 0.121946C1.5173 0.0414376 1.72562 -1.56744e-09 1.936 0C2.14638 1.56745e-09 2.35469 0.0414376 2.54906 0.121946C2.74342 0.202455 2.92003 0.320458 3.06879 0.469219L10.444 7.84442C11.0706 8.47108 11.0706 9.48336 10.444 10.11L3.06879 17.4852C2.92014 17.6342 2.74357 17.7523 2.54919 17.833C2.35481 17.9136 2.14644 17.9551 1.936 17.9551C1.72556 17.9551 1.51718 17.9136 1.3228 17.833C1.12842 17.7523 0.951854 17.6342 0.803203 17.4852C0.19262 16.8586 0.176552 15.8302 0.803203 15.2036Z' />
    </svg>
  );
}
